(ns manage.content-variant-page.rule.db
  (:require [common.ui.validation.db :as validation]
            [datascript.core :as d]
            [manage.content-configuration-page.placeholder-expression.db :refer [singular-placeholder-expression]]
            [manage.content-configuration-page.rule.db :as rule]
            [manage.content-variant-page.content-configuration.db
             :refer [replace-invalid-chars]]
            [re-frame.core :as rf]
            [re-posh.core :as rp]))

(def dynamic-targeting-rule-suffix "-LEMONPI_WILDCARD")
(def mapped-targeting-rule-value-separator "-")

(defn sync-dynamic-targeting-key-rule-assignments [ds rule placeholder macros]
  (let [existing-phe (d/q rule/query-find-assignment ds rule placeholder)]
    (for [macro macros
          :let [macro-phe (singular-placeholder-expression [] [macro] true)]]
      (if existing-phe
        (assoc macro-phe :db/id existing-phe)
        (rule/assignment rule placeholder macro-phe)))))

(defn find-rule-by-name [ds rule-name]
  (d/q '[:find ?r . :in $ ?cc ?n
         :where
         [?cc :content-configuration/rule ?r]
         [?r :rule/name ?n]]
       ds [:content-configuration/id "default"] rule-name))

(defn update-or-create-rule [existing-rule-eid rule-name rule allow-create-new-rule?]
  (let [rule (merge {:rule/name rule-name :db/id (or existing-rule-eid (str "temp-dbid-rule-" rule-name))} rule)]
    (if existing-rule-eid [rule] (when allow-create-new-rule? (rule/db-create-rule rule)))))

(defn sync-dynamic-targeting-key-rule [ds tk macros]
  (let [{targeting-key-name :variant-feed-key/name {placeholder :db/id} :targeting-key/placeholder {existing-rule :db/id} :dynamic-targeting-key/rule}
        (d/pull ds [:variant-feed-key/name {:dynamic-targeting-key/rule [:db/id]} {:targeting-key/placeholder [:db/id]}] tk)
        rule-name (replace-invalid-chars (str targeting-key-name dynamic-targeting-rule-suffix))
        existing-rule (or existing-rule (find-rule-by-name ds rule-name))
        rule-tr {:dynamic-targeting-key/_rule tk}]
    (concat
     (update-or-create-rule existing-rule rule-name rule-tr true)
     (sync-dynamic-targeting-key-rule-assignments ds [:rule/name rule-name] placeholder macros))))

(rp/reg-event-ds :variant-feed/sync-dynamic-targeting-keys->rules
  (fn [ds [_ vf]]
    (sequence (comp (filter (fn [[_tk p]] @(rf/subscribe [:placeholder/dynamic? p])))
                    (map first)
                    (mapcat #(sync-dynamic-targeting-key-rule ds % []))
                    (remove empty?))
              (d/q '[:find ?tk ?p
                     :in $ ?vf
                     :where
                     [?vf :variant-feed/variant-feed-key ?tk]
                     [?tk :variant-feed-key/type :targeting]
                     [?tk :targeting-key/placeholder ?p]] ds vf))))

(defn sync-mapped-targeting-value-rule [ds tv allow-create-new-rule? default?]
  (let [{targeting-value :targeting-value/value {existing-rule :db/id} :mapped-targeting-value/rule
         {targeting-key-name :variant-feed-key/name {placeholder :db/id} :targeting-key/placeholder} :targeting-key/_targeting-value}
        (d/pull ds [:targeting-value/value {:mapped-targeting-value/rule [:db/id]}
                    {:targeting-key/_targeting-value [:variant-feed-key/name {:targeting-key/placeholder [:db/id]}]}] tv)
        rule-name (replace-invalid-chars (str targeting-key-name mapped-targeting-rule-value-separator targeting-value))
        existing-rule (or existing-rule (find-rule-by-name ds rule-name))
        assignment-dbid (or (d/q rule/query-find-assignment ds existing-rule placeholder) (str "temp-dbid-phe-for-tv:" tv))
        rule-tr {:mapped-targeting-value/_rule tv
                 :rule/assignment [(rule/assignment
                                    (or existing-rule [:rule/name rule-name]) placeholder
                                    (cond-> (assoc (singular-placeholder-expression [targeting-value] [] false)
                                                   :db/id assignment-dbid
                                                   :targeting-value/_placeholder-expression tv)
                                      default? (assoc :placeholder/_default-value placeholder)))]}]
    (update-or-create-rule existing-rule rule-name rule-tr allow-create-new-rule?)))

(rp/reg-event-ds :variant-feed/sync-mapped-targeting-values->rules
  (fn [ds [_ vf]]
    (sequence (comp (filter (fn [[_tv p]] (not @(rf/subscribe [:placeholder/dynamic? p]))))
                    (mapcat (fn [[tv p]]
                              (sync-mapped-targeting-value-rule
                               ds tv false
                               ;; if the targeting value matches the placeholder
                               ;; expression default value, then ensure this
                               ;; targeting value is marked as default
                               (= (d/q '[:find ?v . :in $ ?tv :where [?tv :targeting-value/value ?v]] ds tv)
                                  (first (d/q '[:find ?s . :in $ ?p
                                                :where
                                                [?p :placeholder/default-value ?phe]
                                                [?phe :singular-placeholder-expression/strings ?s]] ds p)))))))
              (d/q '[:find ?tv ?p
                     :in $ ?vf
                     :where
                     [?vf :variant-feed/variant-feed-key ?tk]
                     [?tk :variant-feed-key/type :targeting]
                     [?tk :targeting-key/placeholder ?p]
                     [?tk :targeting-key/targeting-value ?tv]] ds vf))))

(rp/reg-query-sub :rule/mapped-targeting-value
  '[:find ?tv . :in $ ?r :where [?tv :mapped-targeting-value/rule ?r]])

(rf/reg-sub :rule/allow-delete?
  (fn [[_ r]]
    (rf/subscribe [:rule/mapped-targeting-value r]))
  (fn [mapped-targeting-value _]
    (nil? mapped-targeting-value)))

(defmethod validation/validation-schema :mapped-rule
  [_schema value]
  {:validation/schema :rule
   :validation/value (assoc
                      value
                      :mapped-rule/has-targeting-value?
                      (some? @(rf/subscribe [:rule/mapped-targeting-value (:db/id value)])))})
